<template>
  <LayoutCliente>
    <PropostaEnviada />
  </LayoutCliente>
</template>

<script>
import LayoutCliente from "@/Layouts/LayoutCliente.vue";
import PropostaEnviada from "@/components/Cliente/PropostaEnviada.vue";
export default {
  components: { LayoutCliente, PropostaEnviada },
};
</script>

<style>
</style>